<!-- =========================================================================================
  File Name: ListView.vue
  Description: Data List - List View
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="data-list-list-view" class="data-list-container">
    <data-view-sidebar :isSidebarActive="addNewDataSidebar" @closeSidebar="toggleDataSidebar" :data="sidebarData"/>
    <reset-admin-password-side-bar  :isResetPasswordSidebarActive="AdminPasswordSidebar" @closeSidebar="togglePassswordSidebar" :data="passwordSidebarData"/>
    <!-- ADD NEW -->
    <div>
    <vs-button class="user_add_btn" type="filled" @click="addNewData"><feather-icon icon="PlusIcon" class="flex-inline" svgClasses="h-3 w-3" /> New Admin</vs-button>
     <!-- <vs-button class="user_add_btn" radius icon="icon-plus" icon-pack="feather"    @click="addNewData"/> -->
  </div>
    <vs-table ref="table"  pagination :max-items="itemsPerPage" search
              :data="admin_users">

      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

        <div class="flex flex-wrap-reverse items-center data-list-btn-container">

          <!-- ACTION - DROPDOWN -->
          <vs-dropdown v-if="select>0" vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Actions  ({{selected.length}})</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
            </div>

            <vs-dropdown-menu>
               <vs-dropdown-item>
                <span class="flex items-center"  @click="selectAction('status')">
                  <feather-icon icon="ToggleRightIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Enable</span>
                </span>
              </vs-dropdown-item>
               <vs-dropdown-item>
                <span class="flex items-center"  @click="selectAction('disablestatus')">
                  <feather-icon icon="ToggleLeftIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Disabled</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item>
                <span class="flex items-center" @click="selectAction('deleteuser')">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                  <span>Delete</span>
                </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>

          <!-- FILTER -->
          <!-- FILTER -->
          <!-- <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter">Search By Location</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="setSelected('Search By Location')">
                <span class="flex items-center">
                  <span  >All</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="location in locations" :key="location.id" @click="setSelected(location.name)">
                <span class="flex items-center">
                  <span >{{ location.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown> -->

          <!-- ADD NEW -->
<!--          <div-->
<!--            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"-->
<!--            @click="addNewData">-->
<!--            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>-->
<!--            <span class="ml-2 text-base text-primary">Add New</span>-->
<!--          </div>-->
          <vx-tooltip text="Search By Status" position="top">
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">

            <div
              class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2" v-html="custom_search_filter_status">Search By Status</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="statusSelected('Search By Status')">
                <span class="flex items-center">
                  <span>All</span>
                </span>
              </vs-dropdown-item>
              <vs-dropdown-item v-for="status in statuses" :key="status.id" @click="statusSelected(status.name)">
                <span class="flex items-center">
                  <span >{{ status.name }}</span>
                </span>
              </vs-dropdown-item>

            </vs-dropdown-menu>
          </vs-dropdown>
          </vx-tooltip>


        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ admin_users.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : admin_users.length }} of {{ queriedCamUsers }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=25">
              <span>25</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=50">
              <span>50</span>
            </vs-dropdown-item>
            <!-- <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item> -->
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-checkbox v-model="headCheckbox" @input="CheckAll()"></vs-checkbox>
        <vs-th sort-key="name">Image</vs-th>
        <vs-th sort-key="name">Name</vs-th>
        <vs-th sort-key="roles">Role</vs-th>
        <vs-th sort-key="email">Email</vs-th>
        <!-- <vs-th sort-key="order_status">EMAIL CONFIRMED</vs-th> -->
        <vs-th sort-key="order_status">Status</vs-th>
        <vs-th>Action</vs-th>
      </template>

        <template slot-scope="{data}">
          <tbody>

            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td><vs-checkbox  @input="SelectItem(tr.id)" v-model="selectedCheck[indextr]"></vs-checkbox></vs-td>
            <vs-td class="img-container" v-if="tr.avatar">
                 <div  class="relative inline-flex mx-auto">
                    <vs-avatar class="m-0" :src="img_cdn + tr.avatar" size="50px" />
                    <div class="h-5 w-5 border-white border-2 border-solid rounded-full absolute right-0 bottom-0" :class="'bg-' + getStatusColor(tr.active)"></div>
                </div>
              </vs-td>
              <vs-td v-else>
              <div  class='icon-container'>
              <p class="bg-primary not-found text-white" :data-letterstudent=tr.fname[0].toUpperCase()></p>
              <div class='status-circle ' :class="'bg-' + getStatusColor(tr.last_login_time)">
             </div>
             </div>
            </vs-td>
              <vs-td>
                <p class="product-name font-medium truncate">{{ tr.fname }} {{ tr.middle_name }} {{ tr.lname }} </p>
                <p class="product-category"><a :href="`tel:${tr.phone}`" @click.stop="">{{ tr.phone }}</a></p>
              </vs-td>
              <vs-td>
                <ul><li v-for="role in tr.roles" style="display: flex" :key="role.id"><vs-chip >{{ role.name }}</vs-chip></li></ul>

              </vs-td>

              <vs-td>
                <p class="product-category"><a :href="`mailto:${tr.email}`" @click.stop="">{{ tr.email }}</a></p>
              </vs-td>
              <!-- <vs-td>
                <vs-switch @input="updateEmailStatus(tr.id,tr.email_confirmed)" v-model="tr.email_confirmed"></vs-switch>
              </vs-td> -->
              <vs-td>

                <vs-switch @input="updateStatus(tr.id,tr.status)" v-model="tr.status"></vs-switch>
              </vs-td>
              <vs-td class="whitespace-no-wrap">

                <!-- ACTION - DROPDOWN -->
                <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer">
                  <div>
                    <feather-icon icon="MoreVerticalIcon" @click.stop="" svgClasses="w-6 h-6 hover:text-primary stroke-current" class="ml-2" />
                  </div>

                  <vs-dropdown-menu>

                    <vs-dropdown-item>
                <span class="flex items-center" @click.stop="editData(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span> Edit </span>
                </span>
                    </vs-dropdown-item>
                    <vs-dropdown-item>
                <span class="flex items-center" @click.stop="deleteData(tr.id)">
                  <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2 "/>
                  <span>Delete</span>
                </span>
                    </vs-dropdown-item>

                    <vs-dropdown-item>
                <span class="flex items-center" @click.stop="passwordData(tr)">
                  <feather-icon icon="EditIcon" svgClasses="h-4 w-4" class="mr-2"/>
                  <span>Password Reset</span>
                </span>
                    </vs-dropdown-item>
<!--                    <vs-dropdown-item>-->
<!--                <span class="flex items-center">-->
<!--                  <feather-icon icon="SettingsIcon" svgClasses="h-4 w-4" class="mr-2"/>-->
<!--                  <span>Settings</span>-->
<!--                </span>-->
<!--                    </vs-dropdown-item>-->

                </vs-dropdown-menu>
                </vs-dropdown>
                <!--                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData(tr)" />-->
                <!--                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />-->
              </vs-td>
<!--              <vs-td class="whitespace-no-wrap">-->
<!--&lt;!&ndash;                <router-link :to="{ path: '/camuser-view/'+ tr.id}" class="text-inherit underline"> <feather-icon icon="EyeIcon" @click.stop="" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" /></router-link>&ndash;&gt;-->
<!--                <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" class="ml-2" @click.stop="editData(tr)" />-->
<!--                <feather-icon icon="TrashIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="deleteData(tr.id)" />-->
<!--                <feather-icon icon="SettingsIcon" svgClasses="w-5 h-5 hover:text-danger stroke-current" class="ml-2" @click.stop="userSettingData(tr)" />-->

<!--              </vs-td>-->

            </vs-tr>
          </tbody>
        </template>
    </vs-table>
       <div class="demo-alignment">
      <div class="fill-row-loading">
        <div :class="{'activeLoading':activeLoading}"  :id="[`loading-sound`]" class="vs-con-loading__container loading-example">
        </div>
      </div>
  </div>
  </div>
</template>

<script>
import DataViewSidebar from './DataViewSidebar.vue'
import {
  ADMIN_USERS_LIST,
  REMOVE_USER,
  UPDATE_MANAGER_EMAIL_STATUS,
  UPDATE_USER_STATUS,
  USER_EMAIL_CONFIRMED
} from '@/graphql'
import ResetAdminPasswordSideBar from './ResetAdminPasswordSidebar'

export default {
  components: {
    DataViewSidebar,
    ResetAdminPasswordSideBar
  },
  data () {
    return {
      headCheckbox:'',
      selectedCheck:[],
      img_cdn:'',
      roles:[],
      AdminPasswordSidebar:false,
      admin_users:[],
      custom_search_filter:'Search By Location',
      custom_search_filter_status:'Search By Status',
      statuses:[
        {
          id:'1',
          name:'Active'
        },
        {
          id:'2',
          name:'Disabled'
        },
        {
          id:'3',
          name:'Pending'
        },
        {
          id:'4',
          name:'Offline'
        },
        {
          id:'5',
          name:'Online'
        }
      ],
      selected: [],
      itemsPerPage: 10,
      isMounted: false,
      activeLoading:false,
      // Data Sidebar
      addNewDataSidebar: false,
      sidebarData: {},
      passwordSidebarData:{},
    }
  },
  computed: {
    //   filteredUsersList: function () {
    //   var parameter = this.$route.params.status
    //   var custom_search_filter_status = this.custom_search_filter_status
    //   var custom_search_filter = this.custom_search_filter
    //   return this.admin_users.filter(function(cam_user) {
    //   if(parameter!='pending' && parameter!='online'){
    //     if( custom_search_filter_status != 'Search By Status' && custom_search_filter == 'Search By Location')
    //     {
    //       if(custom_search_filter_status=="Active"){
    //          if(cam_user.email_confirmed && cam_user.order_status){
    //             return true
    //          }
    //         return false
    //       }
    //       if(custom_search_filter_status=="Disabled"){
    //          if(cam_user.email_confirmed==false && cam_user.order_status==false){
    //             return true
    //          }
    //         return false
    //       }
    //       if(custom_search_filter_status=="Pending"){
    //          if(cam_user.email_confirmed==false && cam_user.order_status==true){
    //             return true
    //          }
    //         return false
    //       }
    //       if(custom_search_filter_status=="Offline"){
    //          if(!cam_user.active){
    //             return true
    //          }
    //         return false
    //       }
    //       if(custom_search_filter_status=="Online"){
    //          if(cam_user.active){
    //             return true
    //          }
    //         return false
    //       }
    //     }
    //     if (custom_search_filter == 'Search By Location') {
    //      return true;
    //     }
    //     if(custom_search_filter !== 'Search By Location'){
    //     return cam_user.locations.match(custom_search_filter);
    //     }
    //     return true;
    //     }
    //    if(parameter=='pending'){
    //       if(cam_user.email_confirmed==false && cam_user.order_status==true){
    //             return true
    //          }
    //         return false
    //    }
    //    if(parameter=='online'){
    //       if(cam_user.active){
    //             return true
    //          }
    //         return false
    //    }
    //   });
    // },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },

    select() {
      return this.selected.length
    },
    queriedCamUsers() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.admin_users.length
    }
  },
  methods: {
 ConfirmNotification(status) {
      this.$vs.notify({
        title: "Admin",
        text: 'Admin '+status+' Successfully',
        color: 'success',
        position: 'top-right'
      })
    },
selectAction(action){
if(this.selected.length>0){
     this.$apollo
              .mutate({
                mutation: USER_EMAIL_CONFIRMED,
                variables: {
                  name: action,
                  user_ids: this.selected,
                }
              }).then(response => {
              if(response){
                this.ConfirmNotification(response.data.confirmUserEmail.status)
                this.selected=[];
                this.headCheckbox=false
                 for (let index = 0; index < this.selectedCheck.length; index++) {
                     this.selectedCheck[index]=false;
                 }
                this.getAdminUserList();
              }
            }).catch(error => {

            });
}
},
    CheckAll(){
    var selected=[]
    if(this.headCheckbox){
    for (let index = 0; index < this.admin_users.length; index++) {
                 this.selectedCheck[index]=true;
                 selected.push(this.admin_users[index].id)
                 }
        this.selected=selected
    }
    else{
      for (let index = 0; index < this.admin_users.length; index++) {
                 this.selectedCheck[index]=false;
                 }
        this.selected=[]
    }
  },
   SelectItem(id){
    if(!this.headCheckbox){
    var status=false
    for (var i = 0; i < this.selected.length; i++) {
    if (this.selected[i] == id) {
       status=true
    }
  }
  if(status){
  this.selected.pop(id)
  }
  else{
      this.selected.push(id)
  }
}
else{
    const index = this.selected.indexOf(id);
   if (index > -1) {
     this.selected.splice(index, 1);
  }
  else{
     this.selected.push(id)
  }
}
},
    updateEmailStatus(id,email_confirmed) {
      this.$apollo
        .mutate({
          mutation: UPDATE_MANAGER_EMAIL_STATUS,
          variables: {
            id :id,
            email_confirmed: email_confirmed,
          }
        }).then(response => {
        if(response){
          this.$vs.notify({
            title: 'Email Status',
            text: 'Updated Sucessfully',
            color: 'success',
            position: 'top-right'
          })
        }
      })
    },
    updateStatus(id, status) {
      this.$apollo
        .mutate({
          mutation: UPDATE_USER_STATUS,
          variables: {
            id :id,
            status: status,
          }
        }).then(response => {
        if(response){
          this.$vs.notify({
            title: 'Status',
            text: 'Updated Sucessfully',
            color: 'success',
            position: 'top-right'
          })

        }
      })
    },
     StatusSuccess() {
      this.$vs.notify({
        title: "User",
        text: 'User Deleted Successfully!',
        color: 'success',
        position: 'top-right'
      })},
    setSelected(value) {
    if(this.$router.params.status!='undefined'){
      this.$route.push('/users')
     }
      this.custom_search_filter = value;
    },
    statusSelected(value) {
      if(this.$route.params.status!='undefined'){
      this.$router.push('/users')
     }
      this.custom_search_filter_status = value;
    },
    addNewData() {
      this.sidebarData = {}
      this.toggleDataSidebar(true)
    },

    deleteData (id) {
      this.$apollo
        .mutate({
          mutation: REMOVE_USER,
          variables: {
            id: id,
          },
        })
        .then(response => {
          if (response) {
            this.getAdminUserList()
            this.StatusSuccess();

          }
        })
    },
    editData (data) {
      this.sidebarData = data
      this.toggleDataSidebar(true)
    },
    passwordData (data) {
      this.passwordSidebarData = data
      this.togglePassswordSidebar(true)
    },
    togglePassswordSidebar (val = false) {
      this.AdminPasswordSidebar = val
      if(!val){
        this.getAdminUserList()
      }
    },
    toggleDataSidebar (val = false) {
      this.addNewDataSidebar = val
      this.getAdminUserList()
    },
    removeStudent(student,user){
     console.log(student , user)
    },
      getStatusColor(val) {
        if (val === true) {
          return 'success'
      }
      else {
          return 'grey'
        }
      },
  getAdminUserList(){
     this.$apollo
       .mutate({
         mutation: ADMIN_USERS_LIST,
       })
      .then(response => {
        this.admin_users=response.data.getAdminUsersList
        this.activeLoading = false
        this.$vs.loading.close()

      })

  },

  },
  created () {
    this.img_cdn=process.env.VUE_APP_IMAGES_CDN_LINK
    this.getAdminUserList()

  },
  mounted () {
    this.isMounted = true
  },
    beforeCreate() {
    this.activeLoading = true
      this.$vs.loading({
        type:'sound',
      })
  }
}
</script>

<style lang="scss">

#data-list-list-view {
  .user_add_btn{
    float: right ;
    margin-top: -50px
  }
  @media (max-width: 461px) {
    .user_add_btn {
      margin-top: 60px
    }
  }
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */

    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search{
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr{
          box-shadow: 0 4px 20px 0 rgba(0,0,0,.05);
          td{
            padding: 20px;
            &:first-child{
              border-top-left-radius: .5rem;
              border-bottom-left-radius: .5rem;
            }
            &:last-child{
              border-top-right-radius: .5rem;
              border-bottom-right-radius: .5rem;
            }
          }
          td.td-check{
            padding: 20px !important;
          }
      }
    }

    .vs-table--thead{
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text{
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check{
        padding: 0 15px !important;
      }
      tr{
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
       .product-img {
                height: 70px;
                border-radius: 50%;
              }
   [data-letterstudent]:before {
  content:attr(data-letterstudent);
  }
  .not-found{
  display:inline-block;
  font-size:35px;
  width:50px;
  height:50px;
  text-align:center;
  border-radius:50%;
  vertical-align:middle;
  margin-right:1em;
  }
  .icon-container {
  width: 50px;
  height: 50px;
  position: relative;
}
.status-circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background-color:transparent;
  border: 2px solid white;
  bottom: 0;
  right: 0;
  position: absolute;
}
  }
}
</style>
